import axios from 'axios'
import { showToast } from 'vant'

const service = axios.create({
  baseURL: 'https://api.gjhjxs.vip',
  timeout: 30000
})

service.interceptors.request.use(
  config => {
    config.data = config.data || {}
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 1) {
      showToast({ message: res.info || '请求失败', position: 'top' })
      return Promise.reject(res)
    }
    return res
  },
  error => {
    showToast({ message: '网络错误，请稍后重试', position: 'top' })
    return Promise.reject(error)
  }
)

export default service
